<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
    <el-tab-pane label="用戶授权" name="auth-user-panel">
      <authUserList></authUserList>
    </el-tab-pane>
    <el-tab-pane label="机构授权" name="auth-unit-panel">
      <authUnitList></authUnitList>
    </el-tab-pane>
    <el-tab-pane label="职务授权" name="auth-job-panel">
      <authJobList></authJobList>
    </el-tab-pane>
    <el-tab-pane label="分组授权" name="auth-group-panel">
      <authGroupList></authGroupList>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import authUserList from './authUserList'
import authUnitList from './authUnitList'
import authGroupList from './authGroupList'
import authJobList from './authJobList'

export default {
  created() {
  },
  components: {
    authUserList,
    authUnitList,
    authGroupList,
    authJobList
  },
  methods: {
    handleClick(tab, event) {
    }
  },
  data() {
    return {
      activeName: this.$route.params.active || 'auth-user-panel'
    }
  }
}
</script>

<style scoped></style>
